import { createVehicleHasProvinceRequest } from "../../data/vehicleHasProvinceApi";
import { validateVehicleHasProvincePayload } from "../validator/validateVehicleHasProvincePayload";

export async function createVehicleHasProvinceUseCase(payload) {
  const error = validateVehicleHasProvincePayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await createVehicleHasProvinceRequest(payload);
}
